module.exports = __webpack_public_path__ + "img/sms.c146c06d.png";